import { render, staticRenderFns } from "./register-step2.vue?vue&type=template&id=df3dd008"
import script from "./register-step2.vue?vue&type=script&lang=js"
export * from "./register-step2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports